var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"max-button",attrs:{"disabled":_vm.loading}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c(_vm.iconComponent,{tag:"component"}):_vm._e(),(_vm.loading)?_c('span',[_vm._v("Loading...")]):_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }